import classnames from 'classnames';
import * as React from 'react';
import { Icon } from '../icons/index.js';
import '../visually_hidden/index.js';
import { icon, avatar, size } from './avatar.css.js';
import { VisuallyHidden } from '../visually_hidden/visually_hidden.js';

/**
 * Visual representation of user or company entity.
 */
const Avatar = React.forwardRef(function Avatar({ firstName, lastName, entityType = 'user', size: size$1 = 'medium', onClick, children, className, ...rest }, ref) {
    const getContent = () => {
        if (entityType === 'user') {
            if (firstName && lastName) {
                return getInitials(firstName, lastName);
            }
            return React.createElement(Icon, { name: 'small-user', className: icon });
        }
        if (entityType === 'company') {
            return React.createElement(Icon, { name: 'small-company', className: icon });
        }
        return null;
    };
    const isUsedAsButton = onClick !== undefined;
    const content = (React.createElement(React.Fragment, null,
        React.createElement("span", { "aria-hidden": !!children }, getContent()),
        children && React.createElement(VisuallyHidden, null, children)));
    if (isUsedAsButton) {
        return (React.createElement("button", { ...rest, ref: ref, className: classnames(avatar, size[size$1], className), type: "button", onClick: onClick }, content));
    }
    return (React.createElement("span", { ...rest, className: classnames(avatar, size[size$1], className) }, content));
});
const getInitials = (firstName, lastName) => {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`;
};

export { Avatar };
